import styled from "styled-components";
import { COLORS, TYPOGRAPHY } from "../../../../constants";
import { StyledTableCell } from "components/filesListTable/styles";
import { Button } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

export const StyledCellTitle = styled(StyledTableCell)`
  width: 40%;
`;

export const StyledCellCommon = styled(StyledTableCell)`
  width: 16%;
`;

export const StyledCellAction = styled(StyledTableCell)`
  width: 7%;
`;

export const StyledMenu = styled(Menu)`
  &&&& {
    margin-top: 36px;
    margin-left: -50px;
  }

  .MuiMenu-list {
    display: flex;
    flex-direction: row;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 6px;
    padding-bottom: 6px;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  &&.MuiListItem-gutters {
    padding-left: 4px;
    padding-right: 4px;
  }
`;

export const StyledButton = styled(Button)`
  && {
    width: ${(props) => (props.width ? props.width : "100px")};
    height: 27px;
    background-color: white;
    border: 2px solid ${(props) =>
      props.title == "invite/publish"
        ? COLORS.primaryGreen
        : props.title == "delete"
        ? COLORS.primaryRed
        : props.title == "edit"
        ? COLORS.primaryGreen
        : props.title == "amend"
        ? COLORS.disabledGrey
        : props.title == "cancel" || props.title == "archive"
        ? COLORS.primaryRed
        : props.title == "review"
        ? "#71A6FF"
        : props.title == "submissions"
        ? "#71A6FF"
        : props.title == "view"
        ? COLORS.primaryOrange
        : COLORS.lightGrey1};
    box-sizing: border-box;
    border-radius: 6px;
    color: ${(props) =>
      props.title == "invite/publish"
        ? COLORS.primaryGreen
        : props.title == "delete"
        ? COLORS.primaryRed
        : props.title == "edit"
        ? COLORS.primaryGreen
        : props.title == "amend"
        ? COLORS.primaryGreen
        : props.title == "cancel" || props.title == "archive"
        ? COLORS.primaryRed
        : props.title == "review"
        ? "#71A6FF"
        : props.title == "submissions"
        ? "#71A6FF"
        : props.title == "view"
        ? COLORS.primaryOrange
        : COLORS.lightGrey1};

    font-family: SF Pro Text;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.5s ease;
    text-transform: uppercase;

    &:hover {
      background-color: ${(props) =>
        props.title == "invite/publish"
          ? COLORS.primaryGreen
          : props.title == "delete"
          ? COLORS.primaryRed
          : props.title == "edit"
          ? COLORS.primaryGreen
          : props.title == "amend"
          ? COLORS.primaryGreen
          : props.title == "cancel" || props.title == "archive"
          ? COLORS.primaryRed
          : props.title == "review"
          ? "#71A6FF"
          : props.title == "submissions"
          ? "#71A6FF"
          : props.title == "view"
          ? COLORS.primaryOrange
          : COLORS.lightGrey1};
      color: white;
    }
`;

export const StyledStatus = styled.div`
  font-family: ${TYPOGRAPHY.primaryFont};
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0px;
  text-align: center;
  color: ${(props) => props.textColor || "black"};
  background-color: ${(props) => props.backgroundColor || "white"};
  border-radius: 10px;
  width: 78px;
  height: 18px;
  padding-top: 2px;

  &::first-letter {
    text-transform: capitalize;
  }
`;
